module.exports = __webpack_public_path__ + "img/goldIcon.9c33ec56.svg";